import React, { useState, useEffect } from 'react';
import { FaTimes, FaAtom } from 'react-icons/fa';
import './WorldNuclearDayBanner.css';

// Bump this key (e.g. to "-2027") if you want the banner to reappear
// for everyone next year, even for people who dismissed it before.
const DISMISS_KEY = 'nsk-wned-banner-dismissed-2026';

const BALLOONS = ['🎈', '🎈', '🎈'];

// Short, punchy lines joined into one continuous ticker.
const TAGLINE =
  'Powering tomorrow, today. ⚛️   •   80+ years of nuclear progress in Kenya. 🎉   •   ' +
  'Clean energy. Reliable power. 🌍   •   Join the celebration this Dec 2nd! 🎈';

function WorldNuclearDayBanner() {
  const [dismissed, setDismissed] = useState(true); // start hidden, avoid flash

  useEffect(() => {
    const alreadyDismissed = sessionStorage.getItem(DISMISS_KEY) === 'true';
    setDismissed(alreadyDismissed);
  }, []);

  function handleDismiss() {
    setDismissed(true);
    sessionStorage.setItem(DISMISS_KEY, 'true');
  }

  if (dismissed) return null;

  return (
    <div
      className="wned-banner"
      role="region"
      aria-label="World Nuclear Energy Day announcement"
    >
      <div className="wned-banner__balloons" aria-hidden="true">
        {BALLOONS.map((b, i) => (
          <span
            key={i}
            className="wned-banner__balloon"
            style={{ '--delay': `${i * 1.6}s`, '--x': `${10 + i * 35}%` }}
          >
            {b}
          </span>
        ))}
      </div>

      <div className="wned-banner__inner">
        <div className="wned-banner__identity">
          <span className="wned-banner__icon" aria-hidden="true">
            <FaAtom />
          </span>
          <p className="wned-banner__text">
            <strong>World Nuclear Energy Day</strong>
            <span className="wned-banner__date">Dec&nbsp;2</span>
          </p>
        </div>

        {/* Screen-reader-friendly static version (the moving ticker is hidden from AT) */}
        <p className="wned-banner__sr-only">{TAGLINE.replace(/•/g, ',')}</p>

        <div className="wned-banner__ticker" aria-hidden="true">
          <div className="wned-banner__ticker-track">
            <span className="wned-banner__ticker-item">{TAGLINE}</span>
            <span className="wned-banner__ticker-item">{TAGLINE}</span>
          </div>
        </div>

        <a
          href="https://worldnuclearenergyday.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="wned-banner__cta"
        >
          Learn more
        </a>
      </div>

      <button
        type="button"
        className="wned-banner__close"
        onClick={handleDismiss}
        aria-label="Dismiss World Nuclear Energy Day announcement"
      >
        <FaTimes size={14} />
      </button>
    </div>
  );
}

export default WorldNuclearDayBanner;